import { useState, useEffect } from "react";
import useAxios from "../services/useAxios";
import { Message, MessageSeparator } from "@chatscope/chat-ui-kit-react";
import ContactList from "../components/chat/ContactsList.jsx";
import ChatBox from "../components/chat/ChatBox.jsx";
import "../components/chat/chat.scss";
import useWindowSize from "../hooks/useWindowSize";
import useInterval from "../hooks/useInterval";
import { Helmet } from "react-helmet";
import { translateToReactSelect } from "../utils/helperFunction";
import communication from "../assets/images/communication2.png";

import Loader from "../utils/Loader";
import { LoopCircleLoading } from "react-loadingg";
import { TimeStampToJalali } from "../utils/helperFunction";

export default function ChatPage() {
  const winSize = useWindowSize();
  const [chatboxShow, setChatboxShow] = useState(true);
  const [contactBoxShow, setContactBoxShow] = useState(true);
  const [count, setCount] = useState(true);
  const [tagOption, setTagOption] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const [bankName, setBankName] = useState([]);
  const [tagUpdater, setTagUpdater] = useState(false);

  const { execute: getHashtag } = useAxios("api/Find_tag");
  const { loadingUser, execute: findUser } = useAxios("api/Find_users");
  const { loadingConfig, execute: getConfig } = useAxios("api2/get_configs");
  const [loading, setLoading] = useState(false);
  const [loadingChat, setLoadingChat] = useState(false);
  const [allMsg, setAllMsg] = useState([]);

  const { execute: getChat } = useAxios("api/get_chats");
  useEffect(() => {
    getHashtag().then((result) => {
      setTagOption(translateToReactSelect(false, result, "text"));
    });
  }, [tagUpdater]);

  useEffect(() => {
    if (winSize.width < 700) {
      setChatboxShow(false);
      setContactBoxShow(true);
    } else {
      setChatboxShow(true);
      setContactBoxShow(true);
    }
  }, [winSize.width]);
  const [contacts, setContacts] = useState([]);
  const [contactsSearch, setContactsSearch] = useState([]);

  const [selectedContact, setSelectedContact] = useState("");
  const [searchContact, setSearchContact] = useState("");

  const get_contact = async () => {
    let res = await getChat();
    if (res["status"] == 1 && res["messages"] != []) {
      let array = [];
      Object.keys(res["messages"]).map((item, index) => {
        let mydate = new Date(
          +res["messages"][item]["last_message"]["mtm"] * 1000
        );
        array.push({
          id: res["messages"][item]["agent_info"]["id"],
          mtm: res["messages"][item]["last_message"]["mtm"],

          fullname:
            res["messages"][item]["customer_info"]["corporate"] == 1
              ? `${res["messages"][item]["customer_info"]["company_name"]} (${res["messages"][item]["customer_info"]["firstname"]} ${res["messages"][item]["customer_info"]["lastname"]})`
              : `${res["messages"][item]["customer_info"]["firstname"]} ${res["messages"][item]["customer_info"]["lastname"]}`,
          // res["messages"][item]["customer_info"]["firstname"] +
          // " " +
          // res["messages"][item]["customer_info"]["lastname"],
          lastMessage: res["messages"][item]["last_message"]["text"],
          time: mydate.toLocaleDateString("fa-IR"),
          newMessage:
            res["messages"][item]["unseen_message_count"] > 0 ? true : false,
          newMessageNumber: res["messages"][item]["unseen_message_count"],
          customer_id: res["messages"][item]["customer_info"]["id"],
          reminder_end_tm: res["messages"][item]["reminder_end_tm"],
        });
      });
      if (count) {
        // setSelectedContact(array[0]);
        setCount(false);
      }

      setContacts(
        array.sort((a, b) => {
          return b.mtm - a.mtm;
        })
      );
      if (searchContact == "")
        setContactsSearch(
          array.sort((a, b) => {
            return b.mtm - a.mtm;
          })
        );
    }
    setLoading(false);
  };
  const { execute: allMassage } = useAxios("api/get_chat_info");
  const get_msg = async () => {
    if (selectedContact?.id) {
      let array = [];

      let result = await allMassage({
        user_id: selectedContact?.id,
        customer_id: selectedContact?.customer_id,
      });
      if (result["status"] == 1) {
        let arrayMsg = result["messages"].map((v) => {
          return {
            ...v,
            day: TimeStampToJalali(parseInt(v.mtm) * 1000, "DD"),
            month: TimeStampToJalali(parseInt(v.mtm) * 1000, "MM"),
            year: TimeStampToJalali(parseInt(v.mtm) * 1000, "YYYY"),
          };
        });

        arrayMsg.sort((s1, s2) => {
          return s1["mtm"] - s2["mtm"];
        });

        arrayMsg.map((element, index) => {
          // element["reciver_id"] == userInfo["id"]
          if (
            index == 0 ||
            element?.day != arrayMsg[index - 1]?.day ||
            element?.year != arrayMsg[index - 1]?.year ||
            element?.month != arrayMsg[index - 1]?.month
          ) {
            array.push(
              <MessageSeparator
                content={`${element?.year}/${element?.month}/${element?.day}`}
                as="h2"
              />
            );
          }
          if (element["sender_id"] == selectedContact?.id) {
            if (element["file_path"] != "" && element["file_path"] != null) {
              array.push(
                <Message
                  key={`img${index}`}
                  type="image"
                  model={{
                    direction: "incoming",
                    payload: {
                      src: `http://tatdemo.ir/irancovercrmb/${element["file_path"]}`,
                      width: "300px",
                    },
                  }}
                />
              );
            }
            if (element["text"] != "") {
              array.push(
                <Message
                  key={`text${index}`}
                  model={{
                    message: element["text"],
                    // sentTime: "just now",
                    // sender: "me",
                    direction: "incoming",
                    position: "single",
                  }}
                >
                  {" "}
                  <Message.Footer
                    sentTime={TimeStampToJalali(
                      parseInt(element["mtm"]) * 1000,
                      "HH:MM"
                    )}
                  />
                </Message>
              );
            }
          } else {
            if (element["file_path"] != "" && element["file_path"] != null) {
              array.push(
                <Message
                  key={`img${index}`}
                  type="image"
                  model={{
                    direction: "outgoing",
                    // sentTime: "just now",
                    // sender: "me",
                    payload: {
                      src: `http://tatdemo.ir/irancovercrmb/${element["file_path"]}`,
                      width: "300px",
                    },
                  }}
                >
                  <Message.Footer
                    sentTime={TimeStampToJalali(
                      parseInt(element["mtm"]) * 1000,
                      "HH:MM"
                    )}
                  />
                </Message>
              );
            }
            if (element["text"] != "") {
              array.push(
                element.type == 0 ? (
                  <Message
                    key={`text${index}`}
                    model={{
                      message: element["text"],
                      // sentTime: "1402/02/10",
                      // sender: "me",
                      direction: "outgoing",
                      position: "single",
                    }}
                  >
                    <Message.Footer
                      sentTime={TimeStampToJalali(
                        parseInt(element["mtm"]) * 1000,
                        "HH:MM"
                      )}
                    />
                  </Message>
                ) : element.type == 1 ? (
                  <Message
                    model={{
                      type: "html",
                      // sentTime: "1402/02/10",
                      // sender: "me",
                      direction: "outgoing",
                      position: "single",
                    }}
                  >
                    <Message.HtmlContent
                      html={`<h5 style='color:darkGreen;font-weight:bold;border-bottom:1px solid darkGreen;padding-bottom:5px;background-color:'gray'>یادداشت مدیریتی</h5><div style='margin-top:1px'>${element["text"]}</div>`}
                    />
                    <Message.Footer
                      sentTime={TimeStampToJalali(
                        parseInt(element["mtm"]) * 1000,
                        "HH:MM"
                      )}
                    />
                  </Message>
                ) : (
                  element.type == 2 && (
                    <Message
                      model={{
                        type: "html",
                        // sentTime: "1402/02/10",
                        // sender: "me",
                        direction: "outgoing",
                        position: "single",
                      }}
                    >
                      <Message.HtmlContent
                        html={`<h5 style='color:maroon;font-weight:bold;border-bottom:1px solid maroon;padding:5px;'>یادآور</h5><div style='margin-top:1px'>${element["text"]}</div>`}
                      />
                      <Message.Footer
                        sentTime={TimeStampToJalali(
                          parseInt(element["mtm"]) * 1000,
                          "HH:MM"
                        )}
                      />
                    </Message>
                  )
                )
              );
            }
          }
        });
      }
      setAllMsg(array);
      setLoadingChat(false);
    }
  };
  const scrollToBottom = () => {
    const element = document.getElementById("message-anchor");
    element.scrollIntoView();
  };
  useInterval(get_msg, 2000);
  useEffect(() => {
    async function loadPage() {
      setLoading(true);
      await findUser().then((result) => {
        setUserOption(translateToReactSelect(false, result, "fullname", true));
      });
      await getConfig().then((result) => {
        setBankName(result.banks);
      });
      await get_contact();
    }
    loadPage();
  }, []);

  useInterval(get_contact, 2000);

  return (
    <>
      <Helmet>
        <title>پیام رسان</title>
      </Helmet>
      {loading ? (
        <Loader />
      ) : (
        <div
          className="d-flex bg-white mx-3 mb-3 chat-style"
          style={{
            borderRadius: 20,
            border: "1px solid #0f0f78",
            // maxHeight: winSize.height - 100,
            height: "auto",
            overflow: "hidden",
          }}
        >
          {contactBoxShow && (
            <div
              className="contact-style  scroll-style-contact-list"
              style={{
                width: "30%",
                borderLeft: winSize.width > 700 && "1px solid #0f0f78",
                overflowY: "scroll",
              }}
            >
              <ContactList
                contacts={contacts}
                setContacts={setContacts}
                contactsSearch={contactsSearch}
                setContactsSearch={setContactsSearch}
                setContactBoxShow={setContactBoxShow}
                setChatboxShow={setChatboxShow}
                selectedContact={selectedContact}
                setSelectedContact={setSelectedContact}
                setTagUpdater={setTagUpdater}
                tagOption={tagOption}
                userOption={userOption}
                bankName={bankName}
                setLoadingChat={setLoadingChat}
                searchContact={searchContact}
                setSearchContact={setSearchContact}
                scrollToBottom={scrollToBottom}
              />
            </div>
          )}
          {chatboxShow && (
            <div style={{ width: "70%" }} className="chatbox-style">
              {selectedContact == "" ? (
                <div className="h-100 d-flex flex-column align-items-center justify-content-center">
                  <img style={{ width: "20%" }} src={communication} />
                  <p className="mt-5">برای شروع گفت و گویی را انتخاب کنید.</p>
                </div>
              ) : loadingChat ? (
                <div
                  className="w-100 h-100 position-relative"
                  style={{
                    backgroundColor: "rgb(228, 228, 245)",
                    opacity: "0.3",
                    minHeight: (winSize.height * 80) / 100,
                  }}
                >
                  <div
                    className="position-absolute"
                    style={{
                      // position: "fixed",
                      // left: "0",
                      right: "45%",
                      top: "50%",
                      // bottom: "0",
                      // overflow: "hidden",
                      // backgroundColor: "rgba(209, 225, 240,0.7)",
                      zIndex: 5,
                    }}
                  >
                    <LoopCircleLoading color="rgb(150 150 181)" />
                  </div>
                </div>
              ) : (
                <ChatBox
                  setContactBoxShow={setContactBoxShow}
                  setChatboxShow={setChatboxShow}
                  chatboxShow={chatboxShow}
                  selectedContact={selectedContact}
                  setLoadingChat={setLoadingChat}
                  get_msg={get_msg}
                  allMsg={allMsg}
                />
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
}
